import type { IndicatorStatusCode, MajorIndicatorStatusCode } from 'contracts/tracking-v2/invoice-indicators';

export const STATUS_DESCRIPTION_MAP: Record<IndicatorStatusCode, string> = {
  preparingForTransitWithinDeadline: 'Aguardando saída no prazo',
  preparingForTransitOverDeadline: 'Aguardando saída com atraso',
  preparingForTransitWithoutDeadline: 'Aguardando saída sem prazo',
  inTransitWithinDeadline: 'Em trânsito no prazo',
  inTransitOverDeadline: 'Em trânsito com atraso',
  inTransitWithoutDeadline: 'Em trânsito sem prazo',
  preparingForDeliveryWithinDeadline: 'Aguardando descarga no prazo',
  preparingForDeliveryOverDeadline: 'Aguardando descarga com atraso',
  preparingForDeliveryWithoutDeadline: 'Aguardando descarga sem prazo',
  deliveredWithinDeadline: 'Entregue no prazo',
  deliveredOverDeadline: 'Entregue com atraso',
  deliveredWithoutDeadline: 'Entregue sem prazo',
};

export const MAJOR_STATUS_DESCRIPTION_MAP: Record<MajorIndicatorStatusCode, string> = {
  preparingForTransit: 'Aguardando saída',
  inTransit: 'Em trânsito',
  preparingForDelivery: 'Aguardando descarga',
  delivered: 'Entregue',
};